import { render, staticRenderFns } from "./SettingsIntegrations.vue?vue&type=template&id=2f066fcd&scoped=true&"
import script from "./SettingsIntegrations.vue?vue&type=script&lang=js&"
export * from "./SettingsIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./SettingsIntegrations.vue?vue&type=style&index=0&id=2f066fcd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f066fcd",
  null
  
)

export default component.exports